import React, { useRef, useState } from 'react';
import { SymbolType, CdnObjectType } from '@/types';
import { AudioPlayer, CdnMedia, RoundPlayButton } from '@/components';
import { useAssetCdn } from '@/context/Ui';

interface ManageAdminSymbolsSentenceProps {
  sentence: string;
  includeImage?: boolean;
}

export const ManageAdminSymbolsSentence = ({
  sentence,
  includeImage = true,
}: ManageAdminSymbolsSentenceProps) => {
  const playerRef = useRef<AudioPlayer>(null);

  const mediaUrl = useAssetCdn(
    sentence,
    SymbolType.Sentence,
    CdnObjectType.Audio,
  );

  const [playerReady, setPlayerReady] = useState(false);

  return (
    <>
      <h6 className="font-bold">Sentence: {sentence}</h6>

      {includeImage && (
        <CdnMedia
          className="w-full h-auto"
          symbol={sentence}
          symbolType={SymbolType.Sentence}
          objectType={CdnObjectType.Image}
          width={280}
          height={280}
        />
      )}

      {mediaUrl ? (
        <>
          <AudioPlayer
            ref={playerRef}
            src={mediaUrl}
            onReadySrc={() => setPlayerReady(true)}
          />

          <RoundPlayButton
            onClick={() => {
              playerRef.current?.play();
            }}
            size="sm"
            disabled={!playerReady}
          />
        </>
      ) : (
        <p>Sentence not found</p>
      )}
    </>
  );
};
